module.exports = {
  jobId: "Job ID",
  customerName: "客户",
  productLine: "瓦线类型",
  startUp: "开机时间",
  warranty: "保修时间",
  feeMonth: "费用月度",
  feeType: "费用类型",
  laborCost: "人工成本",
  travelCost: "差旅成本",
  partsCost: "配件成本",
  otherCost: "其他成本",
  salesFee: "销售收入",
  createTime: "提报时间",
  remark: "备注",
  time: "时间",
  dialogTitle: "财务费用提报",
  cancel: "取消",
  confirm: "确认",
  submit: "提交",
  tips: {
    deleteTitle: "删除",
    deleteMessage: "确认删除吗？",
    validNumberError: "请输入数字",
    validJobIdError: "请输入Job ID",
    validFeeMonthError: "请选择费用月度",
    validFeeType: "请选择类型",
  },
  constants: {
    feeType: ["安装", "保内", "保外"],
  },
};
